import { Link } from "react-router-dom";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui, greyMui, rydeColors } from "@ryde/theme";

export const NavigateReportsButtonStyled = styled(
  Link,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "navigate-reports-button",
})`
  color: ${deepPurpleMui.A700};
  display: flex;
  align-items: center;
  gap: 3px;
  margin-inline-start: 25px;
  padding-block: 4px;
  padding-inline: 5px;
  border: 1px solid ${greyMui._200};
  border-radius: 4px;
  &:hover {
    border: 1px solid ${greyMui._300};
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
  }
  label {
    margin-inline-start: 3px;
    cursor: pointer;
    font-size: 14px;
  }
  .NavigateToReportButtonSVG {
    width: auto;
    height: 20px;
    display: block;
  }
`;

export const DashboardPanelTopWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "dashboard-panel-top-wrapper",
})`
  min-width: 100%;
  margin-bottom: 0;
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
`;

export const DashboardPanelTopSettingsStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "dashboard-panel-top-settings",
  },
)`
  width: 100%;
  height: 30px;
  padding-inline-start: 0;
  padding-inline-end: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;
`;
